import React from 'react';
import { parsePaymentString } from './transactionStringParser';

export const TransactionHistory = ({ transactions }) => {
    const parsedTransactions = transactions.map(transaction => parsePaymentString(transaction.detail));

    return (
        <div className="transaction-history">

            {parsedTransactions.length > 0 ? (
                <React.Fragment>
                    <div className="transaction-history__header">Transaction history</div>
                    <div className="transaction-history__list">
                        {parsedTransactions.map((transaction, index) => (
                            transaction && <TransactionItem key={index} transaction={transaction} />
                        ))}
                    </div>
                </React.Fragment>
            ) : (
                <React.Fragment />
            )}
        </div>
    );
};

const TransactionItem = ({ transaction }) => {
    if (transaction.error) {
        return (
            <div className="transaction-history__details transaction-history__details--not-parsed">{transaction.originalTransaction}</div>
        );
    }

    return (
        <div className="transaction-history__details">
            <div className="transaction-history__details__item transaction-history__details__date">{transaction.date}</div>
            <div className="transaction-history__details__item transaction-history__details__method">{transaction.method}</div>
            <div className="transaction-history__details__item transaction-history__details__amount">{transaction.amount}</div>
        </div>
    );
};

export default TransactionHistory;


// WEBPACK FOOTER //
// ./src/parts/Basket/TransactionHystory/TransactionHystory.js